// extracted by mini-css-extract-plugin
module.exports = {"default":"Header_default__UvAG1"};